import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";


function PhotoEditor({ onPhotoSelect }) {
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const readFile = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });

  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener("load", () => resolve(image));
      image.addEventListener("error", (error) => reject(error));
      image.setAttribute("crossOrigin", "anonymous");
      image.src = url;
    });

  async function getCroppedImg(imageSrc, pixelCrop, rotation = 0) {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const safeArea = Math.max(image.width, image.height) * 2;
    canvas.width = safeArea;
    canvas.height = safeArea;

    ctx.translate(safeArea / 2, safeArea / 2);
    ctx.rotate((rotation * Math.PI) / 180);
    ctx.translate(-safeArea / 2, -safeArea / 2);

    ctx.drawImage(
      image,
      (safeArea - image.width) / 2,
      (safeArea - image.height) / 2
    );

    const data = ctx.getImageData(0, 0, safeArea, safeArea);

    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    ctx.putImageData(
      data,
      -pixelCrop.x - (safeArea - image.width) / 2,
      -pixelCrop.y - (safeArea - image.height) / 2
    );

    return new Promise((resolve) => {
      canvas.toBlob((file) => {
        resolve(URL.createObjectURL(file));
      }, "image/jpeg");
    });
  }

  const showCroppedImage = async () => {
    try {
      const croppedImage = await getCroppedImg(
        imageSrc,
        croppedAreaPixels,
        rotation
      );
      setCroppedImage(croppedImage);
    } catch (e) {
      console.error(e);
    }
  };


    const onFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      // Preview for UI
      const imageDataUrl = await readFile(file);
      setImageSrc(imageDataUrl);

      // Send raw File object to parent
      onPhotoSelect(file);
    }
  };

  return (
    <div>
      {/* File chooser ALWAYS visible */}
      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <input
          type="file"
          id="fileInput"
          onChange={onFileChange}
          accept="image/*"
        />
      </div>

      {/* Show cropper & controls only if an image is selected */}
      {imageSrc && (
        <>
          <div
            style={{
              position: "relative",
              background: "#333",
              width: "60%",
              height: "320px",
              margin: "0 auto",
            }}
          >
            <Cropper
              image={imageSrc}
              crop={crop}
              rotation={rotation}
              zoom={zoom}
              aspect={4 / 3}
              onCropChange={setCrop}
              onRotationChange={setRotation}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
            />
          </div>

          <div style={{ marginTop: 20, textAlign: "center" }}>
            <div>
              <label>
                Zoom:
                <input
                  type="range"
                  min={1}
                  max={3}
                  step={0.1}
                  value={zoom}
                  onChange={(e) => setZoom(Number(e.target.value))}
                />
              </label>
            </div>

            <div style={{ marginTop: 10 }}>
              <label>
                Rotation:
                <input
                  type="range"
                  min={0}
                  max={360}
                  step={1}
                  value={rotation}
                  onChange={(e) => setRotation(Number(e.target.value))}
                />
              </label>
            </div>

            <button
              type="button"
              onClick={showCroppedImage}
              // style={{
              //   marginTop: 10,
              //   padding: "8px 14px",
              //   background: "#28a745",
              //   color: "#fff",
              //   border: "none",
              //   borderRadius: "6px",
              //   cursor: "pointer",
              // }}
            >
              Show Result
            </button>
          </div>

          {croppedImage && (
            <div style={{ marginTop: 20, textAlign: "center" }}>
              {/* <p>Result:</p> */}
              <img
                alt="Cropped"
                src={croppedImage}
                style={{
                  maxWidth: "100%",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default PhotoEditor;
